/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AIDatasetReference,
    AIDatasetReferenceFromJSON,
    AIDatasetReferenceFromJSONTyped,
    AIDatasetReferenceToJSON,
} from './';

/**
 * 
 * @export
 * @interface AIModelPartialUpdate
 */
export interface AIModelPartialUpdate {
    /**
     * 
     * @type {AIDatasetReference}
     * @memberof AIModelPartialUpdate
     */
    dataset?: AIDatasetReference;
    /**
     * 
     * @type {{ [key: string]: string | undefined; }}
     * @memberof AIModelPartialUpdate
     */
    parameters?: { [key: string]: string | undefined; };
    /**
     * 
     * @type {string}
     * @memberof AIModelPartialUpdate
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof AIModelPartialUpdate
     */
    trainingTaskId?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AIModelPartialUpdate
     */
    threshold?: number;
    /**
     * 
     * @type {number}
     * @memberof AIModelPartialUpdate
     */
    epoch?: number | null;
    /**
     * 
     * @type {string}
     * @memberof AIModelPartialUpdate
     */
    preprocessingTask?: string | null;
}

export function AIModelPartialUpdateFromJSON(json: any): AIModelPartialUpdate {
    return AIModelPartialUpdateFromJSONTyped(json, false);
}

export function AIModelPartialUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): AIModelPartialUpdate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'dataset': !exists(json, 'dataset') ? undefined : AIDatasetReferenceFromJSON(json['dataset']),
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'trainingTaskId': !exists(json, 'training_task_id') ? undefined : json['training_task_id'],
        'threshold': !exists(json, 'threshold') ? undefined : json['threshold'],
        'epoch': !exists(json, 'epoch') ? undefined : json['epoch'],
        'preprocessingTask': !exists(json, 'preprocessing_task') ? undefined : json['preprocessing_task'],
    };
}

export function AIModelPartialUpdateToJSON(value?: AIModelPartialUpdate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'dataset': AIDatasetReferenceToJSON(value.dataset),
        'parameters': value.parameters,
        'name': value.name,
        'training_task_id': value.trainingTaskId,
        'threshold': value.threshold,
        'epoch': value.epoch,
        'preprocessing_task': value.preprocessingTask,
    };
}


